export default __webpack_public_path__ + "static/SBTi-0d9accdc2ba50e121cae975e70455dfa.svg";